import { init } from '@sentry/vue';
import { getRegisterConfig } from '@golden/sentry-base';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const registerSentry = (options) => {
    const { app, ignoreErrors = [], capacitorInit } = options;
    const config = {
        ...getRegisterConfig(options),
        app,
        logErrors: true,
        tracesSampleRate: 0.001,
        tracingOptions: {
            trackComponents: true
        },
        ignoreErrors,
        sendDefaultPii: true,
        denyUrls: [
            /chrome-extension:\/\//,
            /moz-extension:\/\//,
            /safari-extension:\/\//,
            /extensions\//i,
            /^chrome:\/\//i
        ]
    };
    if (capacitorInit) {
        capacitorInit(config, init);
    }
    else {
        init(config);
    }
};
//# sourceMappingURL=registerSentry.js.map